import { createContext, useContext, useState, useCallback, useEffect } from "react";

const LanguageContext = createContext(null);
const KEY = "kp_lang";

const getInitial = () => {
    if (typeof window === "undefined") return "en";
    try {
        const stored = localStorage.getItem(KEY);
        if (stored === "en" || stored === "te") return stored;
    } catch {}
    return "en";
};

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(getInitial);

    useEffect(() => {
        try {
            localStorage.setItem(KEY, lang);
            document.documentElement.setAttribute("lang", lang === "te" ? "te" : "en");
        } catch {}
    }, [lang]);

    const setLang = useCallback((l) => setLangState(l === "te" ? "te" : "en"), []);
    const toggle = useCallback(() => setLangState((l) => (l === "en" ? "te" : "en")), []);

    const t = useCallback(
        (obj) => {
            if (!obj) return "";
            if (typeof obj === "string") return obj;
            return obj[lang] ?? obj.en ?? "";
        },
        [lang],
    );

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
};
